import { useEffect, useState } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_WATER_SYSTEM_LF_URL_LINK, GET_WATER_SYSTEM_LAT_LONG } from "../../queries/publicQrys/SystemHeaderViewQrys";
import { useWaterSystemSearchModal } from '../reuseableComponents/WaterSystemSearchModalContext';
import { Modal, ModalTitle, ModalContent, ModalFooter, Button } from '@utahdts/utah-design-system';
import './WaterSystemRedirect.css';

const WaterSystemRedirect = () => {
  const { action } = useParams();
  const location = useLocation();
  // Extract everything after /public/water-system-redirect/:action/
  // If there is no extra path, url will be an empty string
  let url = '';
  const match = location.pathname.match(/^\/public\/water-system-redirect\/[^/]+\/(.*)$/);
  if (match && match[1]) {
    url = match[1];
  }
  const { showSystemSelectModal, setShowSystemSelectModal } = useWaterSystemSearchModal();
  const [errorModalContent, setErrorModalContent] = useState(null);
  const [errorModalTitle, setErrorModalTitle] = useState("");
  const history = useHistory();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const waterSystem = sessionStorage.getItem('selectedWaterSystem');
  let waterSystemData = null;
  if (waterSystem) {
    try {
      waterSystemData = JSON.parse(waterSystem);
    } catch (e) {
      console.error("Error parsing selectedWaterSystem from sessionStorage", e);
    }
  }

  const { data, loading, error } = useQuery(GET_WATER_SYSTEM_LF_URL_LINK, {
    variables: { pwsId: waterSystemData ? waterSystemData.pwsId : '' },
    skip: !waterSystemData || action !== 'EQDocs',
  });

  const { data: latLongData, loading: latLongLoading, error: latLongError } = useQuery(GET_WATER_SYSTEM_LAT_LONG, {
    variables: { pwsId: waterSystemData ? waterSystemData.pwsId : '' },
    skip: !waterSystemData || action !== 'Maps',
  });

  useEffect(() => {
    if (showSystemSelectModal || showErrorModal) return;
    if (waterSystemData) {
      switch (action) {
        case 'EQDocs': {
          if (loading) return;
          if (!data || !data.getLFLinkbySystemId || !data.getLFLinkbySystemId.urlLink) {
            setErrorModalTitle("No Folder Found");
            setErrorModalContent("There is no folder yet created in Laserfiche. Please contact Rich Peterson or Hunter Payne.");
            setShowErrorModal(true);
            return;
          }
          window.open(data.getLFLinkbySystemId.urlLink, '_blank');
          history.goBack();
          break;
        }
        case 'Maps': {
          if (latLongLoading) return;
          if (!latLongData || !latLongData.getSystemLatLongCoords) {
            setErrorModalTitle("No Location Found");
            setErrorModalContent("There is no location set for WS001.");
            setShowErrorModal(true);
            return;
          }
          const { latitude, longitude } = latLongData.getSystemLatLongCoords;
          if (!latitude || !longitude) {
            history.goBack();
            return;
          }
          const mapsBaseUrl = `https://maps.google.com?q=${latitude},${longitude}`;
          window.open(mapsBaseUrl, '_blank');
          history.goBack();
          break;
        }
        default: {
          if (!url) return;
          // Get query string from browser location
          const queryString = window.location.search || '';
          let redirectUrl = `/${action}/${url}${queryString}`;
          redirectUrl = redirectUrl.replace('%systemId%', encodeURIComponent(waterSystemData.systemId));
          window.location.replace(redirectUrl);
        }
      }
    } else {
      setShowSystemSelectModal(true);
    }
  }, [action, url, waterSystemData, loading, error, data, latLongData, latLongError, latLongLoading, showSystemSelectModal, setShowSystemSelectModal, history, showErrorModal, setErrorModalContent]);

  const handleCloseModal = () => {
    setShowErrorModal(false);
    history.goBack();
  };

  if (showErrorModal) {
    return (
      <div className="utah-design-system">
        <Modal
          className="modal--medium"
          onClose={handleCloseModal}
          onEscape={handleCloseModal}
        >
          <ModalTitle>{errorModalTitle}</ModalTitle>
          <ModalContent id="WaterSystemRedirect-ErrorModal-Content">
            <p>{errorModalContent}</p>
          </ModalContent>
          <ModalFooter id="WaterSystemRedirect-ErrorModal-Footer">
            <Button onClick={handleCloseModal}>Close</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }

  return null;
};

export default WaterSystemRedirect;